import React, { useContext } from 'react';
import styled, { ThemeContext } from 'styled-components';
import { useStaticQuery, graphql } from 'gatsby';
import DefaultTitle from '../../components/DefaultTitle';
import DefaultContainer from '../../components/DefaultContainer';
import Tile from './Tile';


const TilesContainer = styled(DefaultContainer)`
  flex-direction: row;
`;

const Tiles = () => {
  const theme = useContext(ThemeContext);

  const {
    other, room, all, bathroom, kitchen,
  } = useStaticQuery(graphql`
      query {
         room: file(name: { eq: "room" }) {
           childImageSharp {
             fluid(quality: 100, maxWidth: 350) {
               ...GatsbyImageSharpFluid_withWebp
             }
           }
        }
         all: file(name: { eq: "all" }) {
           childImageSharp {
             fluid(quality: 100, maxWidth: 350) {
               ...GatsbyImageSharpFluid_withWebp
             }
           }
        }
         bathroom: file(name: { eq: "bathroom" }) {
           childImageSharp {
             fluid(quality: 100, maxWidth: 350) {
               ...GatsbyImageSharpFluid_withWebp
             }
           }
        }
         kitchen: file(name: { eq: "kitchen" }) {
           childImageSharp {
             fluid(quality: 100, maxWidth: 350) {
               ...GatsbyImageSharpFluid_withWebp
             }
           }
         }
           other: file(name: { eq: "other" }) {
             childImageSharp {
               fluid(quality: 100, maxWidth: 350) {
                 ...GatsbyImageSharpFluid_withWebp
               }
             }
           }
         }
  `);

  return (
    <DefaultContainer>
      <DefaultTitle color={theme.colors.dark}>
        remonty i wykończenia wnętrz
      </DefaultTitle>
      <TilesContainer>
        <Tile text="łazienka" fluid={bathroom.childImageSharp.fluid} to="/lazienka" />
        <Tile text="kuchnia" fluid={kitchen.childImageSharp.fluid} to="/kuchnia" />
        <Tile text="pokój" fluid={room.childImageSharp.fluid} to="/pokoj" />
        <Tile text="wszystko" fluid={all.childImageSharp.fluid} to="/kompleksowy-remont/" />
        <Tile text="coś innego" fluid={other.childImageSharp.fluid} to="/cos-innego" />
      </TilesContainer>
    </DefaultContainer>
  );
};
export default Tiles;
